import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JobInfo } from '@blaze-shared/api-contracts-domain';
import { XhrService } from '@blaze-shared/platform-data-access';

import { GetJobsRequest, JobsApi } from './models/jobs-api';

@Injectable({
  providedIn: 'root',
})
export class JobsApiService implements JobsApi {
  private readonly xhrService = inject(XhrService);

  getJobs<T>(request: GetJobsRequest): Observable<JobInfo<T>[]> {
    return this.xhrService.get('jobs', request);
  }

  postJobsStatus<T>(jobIds: string[]): Observable<JobInfo<T>[]> {
    return this.xhrService.post(`jobs/status`, jobIds);
  }

  postCancelJob(jobId: string): Observable<unknown> {
    return this.xhrService.post(`jobs/${jobId}/cancel`, {});
  }
}
